import { getISODate, parseTimeFromMilliseconds } from "../../helpers";
export var mapKickOffTime = function (x, timezone) {
    x.kickOffTime = "";
    if (x.isInKickOffState) {
        var eventStartDate = getISODate(x.startEventDate, timezone);
        var now = getISODate(new Date().toISOString(), timezone);
        var timeLeft = (!now || !eventStartDate || now >= eventStartDate) ? 0 : now.getTime() - eventStartDate.getTime();
        x.kickOffTime = parseTimeFromMilliseconds(timeLeft);
        if (parseInt(x.kickOffTime) <= 0) {
            x.isInKickOffState = false;
            x.kickOffTime = "";
        }
    }
    return x;
};
//# sourceMappingURL=mapKickOffTime.js.map